/**
 * Context Contact Button.
 * @format
 */

import React from 'react';
import { useStateValue } from '@context/state-context';
import Translate from '@components/translation/translate-text-wrapper';
import { trackHeapForm } from '../../form-components/form-services';

interface ContextContactProperties {
  name: string;
  type: string;
  classes?: string;
}

/**
 * Contact Button.
 */
const ContextContactButton = ({
  name,
  type,
  classes,
}: ContextContactProperties) => {
  const [{ contactToggle }, dispatch] = useStateValue();

  /**
   * Toggle Contact Form.
   */
  const toggleContactForm = (event: React.MouseEventHandler<HTMLElement>) => {
    event.preventDefault();

    dispatch({
      type: 'toggleContactForm',
      formToggle: { contactFormOpen: !contactToggle.contactFormOpen },
    });

    trackHeapForm({
      title: name,
      type: 'axios',
      id: 'header-context-form',
      region: 'header',
      location: window.location.href,
      submissionType: 'Forms Opened',
      marketoId: 1094,
      productId: -1,
    });
  };

  /**
   * Render.
   */
  if (type === 'link') {
    return (
      <a onClick={(e) => toggleContactForm(e)} className={classes}>
        <Translate>{name}</Translate>
      </a>
    );
  }
  return (
    <button
      type="button"
      onClick={(e) => toggleContactForm(e)}
      className={classes}>
      <Translate>{name}</Translate>
    </button>
  );
};
export default ContextContactButton;
